export type ProtectMode =
  | 'OFF'
  | 'MONITORING'
  | 'BLOCKING'
  | 'BLOCKING_PERIMETER'
  | 'MONITOR_PERIMETER'

export const protectModeShortcutI18nConfig: Record<ProtectMode, string> = {
  OFF: 'title_protectModeShortcut_off',
  MONITORING: 'title_protectModeShortcut_monitor',
  BLOCKING: 'title_protectModeShortcut_block',
  BLOCKING_PERIMETER: 'title_protectModeShortcut_blockAtPerimeter',
  MONITOR_PERIMETER: 'title_protectModeShortcut_monitorAtPerimeter'
}

export const protectModeI18nConfig: Record<ProtectMode, string> = {
  OFF: 'title_ruleModeOff',
  MONITORING: 'title_ruleModeMonitor',
  BLOCKING: 'title_ruleModeBlock',
  BLOCKING_PERIMETER: 'title_ruleModeBlockAtPerimeter',
  MONITOR_PERIMETER: 'title_ruleModeMonitorAtPerimeter'
}

export const allProtectModes: ProtectMode[] = [
  'OFF',
  'MONITORING',
  'BLOCKING',
  'BLOCKING_PERIMETER',
  'MONITOR_PERIMETER'
]
